import { combineReducers } from 'redux'
import mortgageReducer from './mortgage'

const rootReducer = combineReducers({
    mortgage: mortgageReducer,
})
export default rootReducer
